/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingigpost2Inputs */

const en_crosspostingigpost2 = /** @type {(inputs: Crosspostingigpost2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post`)
};

const de_crosspostingigpost2 = /** @type {(inputs: Crosspostingigpost2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag`)
};

/**
* | output |
* | --- |
* | "Post" |
*
* @param {Crosspostingigpost2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingigpost2 = /** @type {((inputs?: Crosspostingigpost2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingigpost2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingigpost2(inputs)
	return de_crosspostingigpost2(inputs)
});
export { crosspostingigpost2 as "crosspostingIgPost" }